export enum Language {
  EN = 'en',
  EN_EN = 'en-EN',
  DE = 'de',
  DE_DE = 'de-DE'
}

export const languages = Object.values(Language);
